export default "__VITE_ASSET__DO73zyCJ__"